const FIRM_LOGOS = [
  "/firms/shark-funded.png",
  "/firms/fundingpips.png",
  "/firms/alpha-capital.png",
  "/firms/upcomers.png",
  "/firms/sure-leverage.png",
  "/firms/funderblu.png",
  "/firms/myfundedfutures.png",
  "/firms/funded-futures-family.png",
];

export default function Promo() {
  return (
    <div className="promo-root">
      <style>{`
        .promo-root {
          width: 100vw; height: 100vh; overflow: hidden; position: relative;
          background: radial-gradient(1200px 700px at 70% -10%, #1b1140 0%, #0a0a16 55%, #07070f 100%);
          font-family: inherit;
        }
        .promo-grid {
          position: absolute; inset: 0; opacity: .35;
          background-image: linear-gradient(rgba(139,92,246,.07) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(139,92,246,.07) 1px, transparent 1px);
          background-size: 56px 56px;
          mask-image: radial-gradient(ellipse at center, black 30%, transparent 75%);
        }
        .promo-glow { position: absolute; border-radius: 9999px; filter: blur(120px); }
        .scene { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; opacity: 0; text-align: center; padding: 0 60px; }

        @keyframes sceneIn { from { opacity: 0; transform: translateY(26px) scale(.985); } to { opacity: 1; transform: translateY(0) scale(1); } }
        @keyframes sceneOut { to { opacity: 0; transform: translateY(-18px) scale(1.01); } }
        @keyframes popIn { 0% { opacity: 0; transform: scale(.6); } 70% { transform: scale(1.06); } 100% { opacity: 1; transform: scale(1); } }
        @keyframes riseIn { from { opacity: 0; transform: translateY(34px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes logoGlow { 0% { opacity: 0; transform: scale(.5) rotate(-8deg); filter: drop-shadow(0 0 0 rgba(139,92,246,0)); } 60% { filter: drop-shadow(0 0 42px rgba(139,92,246,.8)); } 100% { opacity: 1; transform: scale(1) rotate(0); filter: drop-shadow(0 0 26px rgba(139,92,246,.5)); } }
        @keyframes tickerX { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes pulseRing { 0% { box-shadow: 0 0 0 0 rgba(245,197,66,.45); } 100% { box-shadow: 0 0 0 26px rgba(245,197,66,0); } }

        .s1 { animation: sceneIn .8s cubic-bezier(.22,1,.36,1) .2s forwards, sceneOut .6s ease-in 4.6s forwards; }
        .s2 { animation: sceneIn .8s cubic-bezier(.22,1,.36,1) 5.2s forwards, sceneOut .6s ease-in 9.6s forwards; }
        .s3 { animation: sceneIn .8s cubic-bezier(.22,1,.36,1) 10.2s forwards, sceneOut .6s ease-in 14.8s forwards; }
        .s4 { animation: sceneIn .8s cubic-bezier(.22,1,.36,1) 15.4s forwards, sceneOut .6s ease-in 19.8s forwards; }
        .s5 { animation: sceneIn .9s cubic-bezier(.22,1,.36,1) 20.4s forwards; }

        .logo-anim { animation: logoGlow 1.1s cubic-bezier(.22,1,.36,1) .35s both; }
        .rise { opacity: 0; animation: riseIn .7s cubic-bezier(.22,1,.36,1) forwards; }
        .logo-chip { opacity: 0; animation: popIn .55s cubic-bezier(.22,1,.36,1) forwards; }
        .gold-rise { opacity: 0; animation: riseIn .7s cubic-bezier(.22,1,.36,1) 10.5s forwards, pulseRing 1.2s ease-out 11.4s 3; }
      `}</style>

      <div className="promo-grid" />
      <div className="promo-glow" style={{ width: 420, height: 420, left: -120, top: -120, background: "rgba(124,58,237,.25)" }} />
      <div className="promo-glow" style={{ width: 380, height: 380, right: -100, bottom: -120, background: "rgba(59,130,246,.2)" }} />

      {/* Scene 1 — logo reveal */}
      <div className="scene s1">
        <img src="/logo-mark.png" alt="" className="logo-anim" style={{ width: 190, height: 190, borderRadius: 32 }} />
        <p className="rise" style={{ animationDelay: "1s", marginTop: 26, fontSize: 13, letterSpacing: 6, color: "#a78bfa", fontWeight: 600 }}>
          F U N D E D&nbsp;&nbsp;T R A D E R S&nbsp;&nbsp;C L U B
        </p>
        <h1 className="rise" style={{ animationDelay: "1.35s", marginTop: 14, fontSize: 52, fontWeight: 800, color: "#fff", letterSpacing: -1.5 }}>
          Trade funded. <span style={{ background: "linear-gradient(90deg,#8b5cf6,#3b82f6)", WebkitBackgroundClip: "text", color: "transparent" }}>Earn cashback.</span>
        </h1>
      </div>

      {/* Scene 2 — firms */}
      <div className="scene s2">
        <p className="rise" style={{ animationDelay: "5.5s", fontSize: 12, letterSpacing: 4, color: "#a78bfa", fontWeight: 600 }}>EVERY PROP FIRM. ONE HONEST SCOREBOARD.</p>
        <div style={{ display: "flex", gap: 22, marginTop: 36 }}>
          {FIRM_LOGOS.slice(0, 4).map((src, i) => (
            <div key={src} className="logo-chip" style={{ animationDelay: `${5.9 + i * 0.18}s`, width: 92, height: 92, borderRadius: 22, background: src.includes("funderblu") ? "#0d1226" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", padding: 14, boxShadow: "0 12px 40px rgba(0,0,0,.45)" }}>
              <img src={src} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 22, marginTop: 22 }}>
          {FIRM_LOGOS.slice(4).map((src, i) => (
            <div key={src} className="logo-chip" style={{ animationDelay: `${6.7 + i * 0.18}s`, width: 92, height: 92, borderRadius: 22, background: src.includes("funderblu") ? "#0d1226" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", padding: 14, boxShadow: "0 12px 40px rgba(0,0,0,.45)" }}>
              <img src={src} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
            </div>
          ))}
        </div>
        <p className="rise" style={{ animationDelay: "7.8s", marginTop: 30, fontSize: 17, color: "#9ca3af" }}>
          Real reviews · verified payouts · live challenge prices
        </p>
      </div>

      {/* Scene 3 — code FTC cashback */}
      <div className="scene s3">
        <div className="gold-rise" style={{ border: "1.5px solid rgba(245,197,66,.55)", background: "rgba(245,197,66,.1)", borderRadius: 26, padding: "34px 54px" }}>
          <p style={{ fontSize: 13, letterSpacing: 4, color: "#f5c542", fontWeight: 600 }}>USE CODE</p>
          <p style={{ fontSize: 92, fontWeight: 900, color: "#f5c542", letterSpacing: 6, lineHeight: 1.05, marginTop: 4 }}>FTC</p>
        </div>
        <p className="rise" style={{ animationDelay: "11.3s", marginTop: 30, fontSize: 24, fontWeight: 700, color: "#fff" }}>
          Our commission becomes <span style={{ color: "#f5c542" }}>your cashback</span> — up to 15%
        </p>
        <p className="rise" style={{ animationDelay: "11.9s", marginTop: 10, fontSize: 16, color: "#9ca3af" }}>
          on every account, at every listed firm
        </p>
      </div>

      {/* Scene 4 — features */}
      <div className="scene s4">
        <p className="rise" style={{ animationDelay: "15.7s", fontSize: 12, letterSpacing: 4, color: "#a78bfa", fontWeight: 600 }}>BUILT FOR FUNDED TRADERS</p>
        <div style={{ display: "flex", gap: 20, marginTop: 34 }}>
          {[
            ["Honest Reviews", "Member-rated firms with verified badges"],
            ["Payout Proof Feed", "Real payouts, desk-verified certificates"],
            ["FTC Coin Wallet", "Cashback coins, UPI & crypto cashout"],
            ["Refer & Earn", "0.15 coin for you and every friend"],
          ].map(([t, d], i) => (
            <div key={t} className="logo-chip" style={{ animationDelay: `${16.1 + i * 0.2}s`, width: 240, borderRadius: 20, background: "rgba(18,18,31,.9)", border: "1px solid rgba(139,92,246,.3)", padding: "24px 22px", textAlign: "left" }}>
              <p style={{ fontSize: 17, fontWeight: 800, color: "#fff" }}>{t}</p>
              <p style={{ marginTop: 8, fontSize: 13, lineHeight: 1.55, color: "#9ca3af" }}>{d}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scene 5 — CTA */}
      <div className="scene s5">
        <p className="rise" style={{ animationDelay: "20.8s", fontSize: 13, letterSpacing: 6, color: "#a78bfa", fontWeight: 600 }}>JOIN THE CLUB</p>
        <h1 className="rise" style={{ animationDelay: "21.2s", marginTop: 16, fontSize: 58, fontWeight: 900, color: "#fff", letterSpacing: -1 }}>
          fundedtradersclub<span style={{ color: "#8b5cf6" }}>.in</span>
        </h1>
        <div className="rise" style={{ animationDelay: "21.8s", marginTop: 30, background: "linear-gradient(90deg,#3b82f6,#8b5cf6)", borderRadius: 999, padding: "16px 44px", fontSize: 18, fontWeight: 800, color: "#fff", boxShadow: "0 14px 50px rgba(124,58,237,.5)" }}>
          Sign up free — start earning cashback
        </div>
        <p className="rise" style={{ animationDelay: "22.4s", marginTop: 22, fontSize: 13, letterSpacing: 3, color: "#6b7280" }}>
          REVIEWS · PAYOUTS · COINS · REFERRALS
        </p>
      </div>
    </div>
  );
}
